<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header ts-uppercase ts-font-bold">
        {{ $t('paymentTracking.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('paymentTracking.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-2 ts-flex">
            <label class="col-form-label control-label">{{
              $t('paymentTracking.academic')
            }}</label>
            <a-select
              style="width: 100%"
              :allowClear="true"
              v-model.number="model.ac_year_id"
              @change="fetchTerm"
              :options="
                academic.map(el => ({
                  value: el.ac_year_id,
                  label: el.ac_year
                }))
              "
            ></a-select>
          </div>
          <div class="col-sm-12 col-md-2 ts-flex">
            <label class="col-form-label control-label"
              >{{ $t('paymentTracking.term') }}:
            </label>
            <a-select
              style="width: 100%"
              :allowClear="true"
              v-model.number="model.ac_term_id"
              :options="
                term.map(el => ({ value: el.ac_term_id, label: el.term_name }))
              "
            ></a-select>
          </div>
          <div class="col-sm-12 col-md-2">
            <a-select
              v-model="model.student_id"
              mode="multiple"
              :show-search="true"
              :options="
                student.map(el => ({
                  value: el.student_id,
                  label: el.card_number + '-' + el.student_name
                }))
              "
              :placeholder="$t('paymentTracking.searchStudent')"
              style="width: 100%"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            >
            </a-select>
          </div>
          <div class="col-sm-12 col-md-2">
            <a-button type="text" @click.prevent="fetchData">{{ $t('paymentTracking.search') }}</a-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <div id="table-container">
          <ts-table
            :records="resources"
            :columns="columns"
            :loading="loading"
            :rowGroup="{
              field: 'student_name'
            }"
          >
            <template v-slot="{ record }">
              <td class="ts-whitespace-no-wrap">
                {{ record.inv_number }}
              </td>
              <td class="ts-whitespace-no-wrap ts-text-center">
                {{ record.inv_date }}
              </td>
              <td class="ts-whitespace-no-wrap ts-text-center">
                {{ record.reference }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.student_name }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.class_name }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.type }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.ac_year }}
              </td>
              <td class="ts-whitespace-no-wrap ts-text-center">
                {{ record.term_name }}
              </td>
              <td class="ts-whitespace-no-wrap ts-text-center">
                {{ record.total_amount }}
              </td>
              <td class="ts-whitespace-no-wrap ts-text-center">
                <a
                  href="#"
                  v-tooltip="$t('view')"
                  class="mr-2 text-info"
                  @click.prevent="view(record)"
                >
                  <i class="fas fa-eye"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="$t('pdf')"
                  class="mr-2 text-red"
                  @click.prevent="pdf(record)"
                >
                  <i class="fas fa-file-pdf"></i>
                </a>
              </td>
            </template>
          </ts-table>
        </div>
        <ts-card-wrapper class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData">
          </ts-pagination>
        </ts-card-wrapper>
      </div>
    </ts-card>
    <a-modal
      v-model="viewModal"
      :title="$t('receipt.view')"
      @cancel="() => (viewModal = false)"
      :width="modalWidth"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
    >
      <view-receipt
        :resource="viewResource"
        :loading="modalLoading"
        v-if="paymentView == 'receipt'"
      />
      <view-retail-sale
        :resource="viewResource"
        :loading="modalLoading"
        v-if="paymentView == 'retail sale'"
      />
      <view-testing-fee
        :resource="viewResource"
        :loading="modalLoading"
        v-if="paymentView == 'testing fee'"
        width="1200px"
      />
    </a-modal>
    <pdf-preview
      v-model="pdf_view"
      :invoice-id="invoiceId"
      @cancel="value => (pdf_view = value)"
    ></pdf-preview>
    <a-modal
      v-model="pdfModal"
      :title="$t('pdf')"
      @cancel="() => (pdfModal = false)"
      :width="widthPdf"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
    >
      <preview-pdf-component
        :src="src"
        :waiting="waiting"
        v-if="paymentView == 'receipt'"
      />
      <preview-pdf-retail
        :src="src"
        :waiting="waiting"
        v-if="paymentView == 'retail sale'"
      />
    </a-modal>
    <a-modal
      v-model="preview_pdf"
      :title="$t('pdf')"
      @cancel="closeModal"
      width="40%"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
    >
      <preview-pdf-testing :id="id" />
    </a-modal>
  </div>
</template>

<script>
class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

import { mapActions } from 'vuex'
import { mapKeys, camelCase } from 'lodash'
import { Errors } from 'form-backend-validation'
import PdfPreview from '../invoice/component/pdf_preview.vue'
import ViewComponent from '../receipt/comments/view.vue'
import PreviewPdfComponent from '../receipt/comments/pdf-preview'
import PreviewPdfRetail from '../retail-sale/components/pdf-preview'
import PreviewPdfTesting from '../payment-testing/components/pdf-preview'
import ViewReceipt from './components/view-receipt.vue'
import ViewRetailSale from './components/view-retail-sale.vue'
import ViewTestingFee from './components/view-testing-fee.vue'
export default {
  name: 'payment-tracking',
  components: {
    PdfPreview,
    ViewComponent,
    PreviewPdfComponent,
    ViewReceipt,
    ViewRetailSale,
    ViewTestingFee,
    PreviewPdfTesting,
    PreviewPdfRetail
  },
  data() {
    return {
      loading: false,
      term: [],
      academic: [],
      student: [],
      errors: new Errors(),
      inv_number: [],
      pdf_view: false,
      viewModal: false,
      invoiceId: 0,
      waiting: false,
      src: null,
      pdfModal: false,
      preview_pdf: false,
      id: null,
      modalWidth: '400px',
      widthPdf: '50%',
      model: {
        ac_term_id: '',
        ac_year_id: '',
        student_id: undefined
      },
      resources: [],
      pagination: new Pagination(),
      viewResource: {},
      paymentView: null,
      modalLoading: false
    }
  },
  computed: {
    columns() {
      return [
        {
          name: this.$t('paymentTracking.invoice'),
          style: 'text-align: center; width: 8%'
        },
        {
          name: this.$t('paymentTracking.invoiceDate'),
          style: 'text-align: center; width: 6%'
        },
        {
          name: this.$t('paymentTracking.reference'),
          style: 'text-align: center; width: 8%'
        },
        {
          name: this.$t('paymentTracking.studentName'),
          style: 'text-align: left; width: 10%'
        },
        {
          name: this.$t('paymentTracking.class'),
          style: 'text-align: left; width: 15%'
        },
        {
          name: this.$t('paymentTracking.type'),
          style: 'text-align: left; width: 7%'
        },
        {
          name: this.$t('paymentTracking.academicYear'),
          style: 'text-align: left; width: 8%'
        },
        {
          name: this.$t('paymentTracking.term'),
          style: 'text-align: center; width: 7%'
        },
        {
          name: this.$t('paymentTracking.amount'),
          style: 'text-align: center; width: 10%'
        },
        {
          name: this.$t('paymentTracking.action'),
          style: 'text-align: center; width: 7%'
        }
      ]
    }
  },
  created() {
    this.fetchResource({
      fnName: 'academic,term,student'
    })
    this.fetchData()
  },
  methods: {
    ...mapActions('reportPayment', ['paymentTracking', 'getFormViewData']),
    async fetchData(attributes) {
      this.loading = true
      this.paymentTracking(Object.assign({}, this.model, attributes))
        .then(response => {
          this.RECEIVE_RESOURCES(response)
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    RECEIVE_RESOURCES(records) {
      const { data, ...meta } = records
      this.resources = data
      // this.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
      this.$nextTick(() => {
        this.pagination.currentPage = meta.meta.current_page
        this.pagination.lastPage = meta.meta.last_page
        this.pagination.perPage = meta.meta.per_page
        this.pagination.total = meta.meta.total
        this.pagination.from = meta.meta.from
        this.pagination.to = meta.meta.to
      })
    },
    async fetchResource(attributes, findCurrentAcYear = true) {
      let response = await this.getFormViewData({
        params: attributes
      })
      if (attributes.fnName) {
        attributes.fnName.split(',').forEach(fn => {
          this[fn] = response[fn]
        })
      }
      if (findCurrentAcYear) {
        const findCurrentAcademicYear = this.academic.find(
          ac => ac.ac_status_id == 1
        )
        this.model.ac_year_id = findCurrentAcademicYear
          ? findCurrentAcademicYear.ac_year_id
          : ''
      }
    },
    fetchTerm() {
      if (!this.model.ac_year_id) {
        this.$toasted.info('No academic year selected!')
        return
      }
      this.model.ac_term_id = ''
      this.fetchResource(
        {
          fnName: 'term',
          ac_year_id: this.model.ac_year_id
        },
        false
      )
    },
    SET_SHOW_DATA(record) {
      this.showData = record
    },
    view(record) {
      if (record.type.toLowerCase() == 'invoice') {
        this.$router.push({
          name: 'payment-tracking-invoice',
          params: { id: record.id }
        })
        return
      }
      this.viewModal = true
      this.viewResource = {}
      this.paymentView = record.type.toLowerCase()
      if (record.type.toLowerCase() == 'receipt') {
        this.modalLoading = true
        this.getFormViewData({
          params: {
            fnName: 'findReceipt',
            id: record.id
          }
        })
          .then(response => {
            this.viewResource = response.findReceipt
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => (this.modalLoading = false))
        return
      }
      if (record.type.toLowerCase() == 'retail sale') {
        this.modalLoading = true
        this.modalWidth = '800px'
        this.getFormViewData({
          params: {
            fnName: 'findRetailSale',
            id: record.id
          }
        })
          .then(response => {
            this.viewResource = response.findRetailSale
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => (this.modalLoading = false))
        return
      }

      if (record.type.toLowerCase() == 'testing fee') {
        this.modalLoading = true
        this.modalWidth = '600px'
        this.getFormViewData({
          params: {
            fnName: 'findTestingFee',
            id: record.id
          }
        })
          .then(response => {
            this.viewResource = response.findTestingFee
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => (this.modalLoading = false))
        return
      }
    },
    closeModal() {
      this.preview_pdf = false
      this.id = null
    },
    pdf(record) {
      this.paymentView = record.type.toLowerCase()

      if (record.type.toLowerCase() == 'invoice') {
        this.pdf_view = true
        this.invoiceId = record.id
      }

      if (record.type.toLowerCase() == 'receipt') {
        this.pdfModal = true
        this.waiting = true
        this.$store
          .dispatch('receipt/pdf', record.id)
          .then(response => {
            this.src = response.url
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.waiting = false
          })
      }

      if (record.type.toLowerCase() == 'retail sale') {
        this.pdfModal = true
        this.waiting = true
        this.widthPdf = '35%'
        this.$store
          .dispatch('retailSale/pdf', record.id)
          .then(response => {
            this.src = response.url
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.waiting = false
          })
      }

      if (record.type.toLowerCase() == 'testing fee') {
        this.preview_pdf = true
        this.id = record.id
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
